import {DatabaseCode, toDatabaseCode} from "./database-code";

export interface InvoiceAccountType extends DatabaseCode {
}

const invoice: InvoiceAccountType = {
  code: 'Invoice',
  displayValue: {
    id: 'common.entity.invoiceaccount.type.invoice',
    defaultMessage: 'Invoice',
  },
};

const lineItem: InvoiceAccountType = {
  code: 'Line Item',
  displayValue: {
    id: 'common.entity.invoiceaccount.type.lineitem',
    defaultMessage: 'Line Item',
  },
};

const expense: InvoiceAccountType = {
  code: 'Expense',
  displayValue: {
    id: 'common.entity.invoiceaccount.type.expense',
    defaultMessage: 'Expense',
  },
};

export const invoiceAccountType = {
  invoice,
  lineItem,
  expense,
};

export const invoiceAccountTypes = Object.values(invoiceAccountType);

export const toInvoiceAccountType = (code: string): InvoiceAccountType => toDatabaseCode(code, invoiceAccountTypes);
